module.exports = __webpack_public_path__ + "images/emoji/performing_arts.5cc63a5cb07fcd0ae9c6.png";